import {ModuleComponent} from "../../js/module-component";
import Swiper from "swiper/bundle";

// import Swiper and modules styles
export class ModClients extends ModuleComponent{
    ready(){
        super.ready();
        this.withoutAutoplay = this.$root.data(`without-autoplay`);
        const swiperContainer = this.$root.find(`.swiper-container`).get(0);

        if(!swiperContainer) return;

        // El bucle de Swiper necesita bastantes más slides de los que caben en
        // pantalla; con pocos logos todos son visibles, el loop no puede montarse
        // y el marquee se queda congelado. Clonamos el set hasta tener track de sobra.
        this.ensureEnoughSlides(swiperContainer);

        this.swiper = new Swiper(swiperContainer,{
            direction: `horizontal`,
            spaceBetween: 0,
            speed: 3000, // smoother marquee feel
            autoplay: this.withoutAutoplay ? false : {
                delay: 0,
                pauseOnMouseEnter: true, // pausa al pasar el ratón
                disableOnInteraction: false
            },
            loop: true,
            slidesPerView: 'auto',
            allowTouchMove: false
        });
    }

    ensureEnoughSlides(container){
        const wrapper = container.querySelector(`.swiper-wrapper`);
        if(!wrapper) return;

        const originals = Array.from(wrapper.querySelectorAll(`.swiper-slide`));
        if(!originals.length) return;

        const slideWidth = originals[0].getBoundingClientRect().width || 170;
        const trackWidth = originals.length * slideWidth;
        // apuntamos a un track >= ~2.2x el ancho visible para que el loop fluya
        const target = (container.getBoundingClientRect().width || trackWidth) * 2.2;

        let copies = Math.ceil(target / trackWidth) - 1;
        copies = Math.max(copies, 1);   // siempre al menos una copia extra
        copies = Math.min(copies, 6);   // tope de seguridad

        for(let c = 0; c < copies; c++){
            originals.forEach(slide => {
                const clone = slide.cloneNode(true);
                clone.setAttribute(`aria-hidden`, `true`);
                clone.querySelectorAll(`a`).forEach(a => a.setAttribute(`tabindex`, `-1`));
                wrapper.appendChild(clone);
            });
        }
    }
}
